"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_STATUS_TRANSLATION_KEYS = void 0;
exports.ORDER_STATUS_TRANSLATION_KEYS = {
    processing: "processing",
    pending: "pending",
    "on hold": "onHold",
    "pending Payment": "pendingPayment",
    "payment Review": "paymentReview",
    open: "open",
    complete: "complete",
    closed: "closed",
    canceled: "canceled",
    "suspected Fraud": "suspectedFraud",
    new: "new",
};
//# sourceMappingURL=orderStatusHelper.js.map